import React from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';

import { FaExclamation, FaCircleNotch, FaCircle, FaCalendarDay } from 'react-icons/fa'
import { filterContext, sortContext, groupContext, itemContext } from 'context'

export const filterCheck = (filters, item) => {
    const debug = false
    let result = false
    if(Object.keys(filters).length === 0){ return result }
    
    Object.keys(filters).map(filter => {
        if(filterContext[filter] && filterContext[filter]['filter']){
            result = filterContext[filter]['filter'](filters[filter], item)          
        } else if(['START_DATE','END_DATE'].includes(filter)){
            result = filterContext['DATE']['filter']({ START_DATE: filters['START_DATE'], END_DATE: filters['END_DATE']}, item)
        }
    })

    debug && console.log('[filterCheck]', { result, filters, item })
    return result
}

export const sortItems = (sort, items) => {
    let sorted = [...items]
    sortContext[sort['value']] && sortContext[sort['value']]['sort'] && sorted.sort(sortContext[sort['value']]['sort'] )
    if(sort['direction'] === 'DESCENDING'){
        return sorted.reverse()
    } else {
        return sorted
    }
}

export const groupItems = (pageID, data, user) => {
    let groups = {}
    const page = data['pages'][pageID]
    const group = page['group']
    const filters = page['filters']
    const filtered = filters && Object.values(page['filters']).some(value => value)
    const sort = page['sort']
    const statuses = process.env.REACT_APP_DISABLE_COMPLETED ? ['INCOMPLETE']
                    :  user['show_completed'] ? ['INCOMPLETE','COMPLETED'] 
                    : ['INCOMPLETE']

    // Holder for groups
    let items
    switch(group){
        case groupContext.PRIORITY['value']:
            Object.keys(itemContext.PRIORITY).map(priority => {
                if(filtered && filters['PRIORITY'] && !filters['PRIORITY'].includes(priority)){ return }
                groups[priority] = {
                    INCOMPLETE: [],
                    COMPLETED: [],
                    title: itemContext.PRIORITY_TITLE[priority],
                    icon: <FaExclamation style={{ color: itemContext.PRIORITY_COLOR[priority], fontSize: '0.8rem' }}/>,
                    id: priority
                }
            })
            break
        case groupContext.TAGS['value']:
            const tags = Object.values(data['tags']).filter(tag => tag['pageID'] === pageID)
            groups['NO_TAGS'] = {
                INCOMPLETE: [],
                COMPLETED: [],
                title: 'No tags',
                icon: <FaCircleNotch style={{ color: '#5c5c5c', fontSize: '0.8rem' }}/>,
                id: 'NO_TAGS'
            }

            tags.map(tag => {
                if(filtered && filters['TAGS'] && !filters['TAGS'].includes(tag['tagID'])){ return }
                groups[tag['tagID']] = {
                    INCOMPLETE: [],
                    COMPLETED: [],
                    title: tag['content'],
                    icon: <FaCircle style={{ color: tag['color'], fontSize: '0.8rem' }}/>,
                    id: tag['tagID']
                }
            })
            break
        case groupContext.START_DATE['value']:
            items = Object.values(data['items']).filter(item => item['pageID'] === pageID && statuses.includes(item['status']) && item['start_date'])
            let start_dates = items.map(item => moment(item['start_date']).tz(user['timezone']).format('YYYY-MM-DD'))
            start_dates = _.uniq(start_dates)
            start_dates.sort().reverse()

            groups['NO_SCHEDULE'] = {
                INCOMPLETE: [],
                COMPLETED: [],
                title: 'No schedule',
                icon: <FaCalendarDay style={{ color: 'var(--primary-accent-color)', fontSize: '0.8rem' }}/>,
                id: 'NO_SCHEDULE'
            }

            start_dates.map(start_date => {
                if(filtered && filters['START_DATE'] && !moment(start_date).isBetween(moment(filters['START_DATE']), moment(filters['END_DATE']), undefined, '[]')){ return }
                groups[start_date] = {
                    INCOMPLETE: [],
                    COMPLETED: [],
                    title: moment(start_date).format('ddd, D/M'),
                    icon: <FaCalendarDay style={{ color: 'var(--primary-accent-color)', fontSize: '0.8rem' }}/>,
                    id: moment(start_date).format('ddd, D/M')
                }
            })
            break
        case groupContext.DUE_DATE['value']:
            items = Object.values(data['items']).filter(item => item['pageID'] === pageID && statuses.includes(item['status']) && item['end_date'])
            let end_dates = items.map(item => moment(item['end_date']).tz(user['timezone']).format('YYYY-MM-DD'))
            end_dates = _.uniq(end_dates)
            end_dates.sort().reverse()

            groups['NO_SCHEDULE'] = {
                INCOMPLETE: [],
                COMPLETED: [],
                title: 'No schedule',
                icon: <FaCalendarDay style={{ color: 'var(--primary-accent-color)', fontSize: '0.8rem' }}/>,
                id: 'NO_SCHEDULE'
            }

            end_dates.map(end_date => {
                if(filtered && filters['END_DATE'] && !moment(end_date).isBetween(moment(filters['START_DATE']), moment(filters['END_DATE']), undefined, '[]')){ return }
                groups[end_date] = {
                    INCOMPLETE: [],
                    COMPLETED: [],
                    title: moment(end_date).format('ddd, D/M'),
                    icon: <FaCalendarDay style={{ color: 'var(--primary-accent-color)', fontSize: '0.8rem' }}/>,
                    id: moment(end_date).format('ddd, D/M'),
                }
            })
            break
    }

    // Make sure archived sections are last
    let sectionIDs = Object.values(data['pages'][pageID]['sections'])
    let sections = sectionIDs.map(sectionID => data['sections'][sectionID])
    sections.sort((a,b) => (a['status'] === b['status'] ? 0 : a['status'] > b['status'] ? 1 : -1))
    sections = sections.filter(section => section)
    sectionIDs = sections.map(section => section['sectionID'])

    // Loop through sections and add item into groups
    sections.map(section => {
        if(!user['show_archived'] && section['status'] === 'ARCHIVE') { return }
        statuses.map(status => {
            section.items[status].map(itemID => {
                const item = data['items'][itemID]
                if(!item) { return }

                const shouldInclude = filtered ? filterCheck(filters, item) : true
                if(!shouldInclude) { return }

                switch(group){
                    case groupContext.PRIORITY['value']:
                        groups[item['priority']][status].push(item)
                        break
                    case groupContext.TAGS['value']:
                        if(item['tags'].length > 0){
                            item['tags'].map(tagID => {
                                Object.keys(groups).includes(tagID) && groups[tagID][status].push(item)
                            })
                        } else {
                            groups['NO_TAGS'][status].push(item)
                        }
                        break
                    case groupContext.START_DATE['value']:
                        if(item['start_date']){
                            const start_date = moment(item['start_date']).tz(user['timezone']).format('YYYY-MM-DD')
                            Object.keys(groups).includes(start_date) && groups[start_date][status].push(item)
                        } else {
                            groups['NO_SCHEDULE'][status].push(item)
                        }
                        break
                    case groupContext.DUE_DATE['value']:
                        if(item['end_date']){
                            const end_date = moment(item['end_date']).tz(user['timezone']).format('YYYY-MM-DD')
                            Object.keys(groups).includes(end_date) && groups[end_date][status].push(item)
                        } else {
                            groups['NO_SCHEDULE'][status].push(item)
                        }
                        break
                }
            })
        })
    })

    // Sort if needed
    for (const [key, value] of Object.entries(groups)) {        
        statuses.map(status => {
            if(sort && sort['value']){
                value[status] = sortItems(sort, value[status])
            }
        })
    }

    return groups
}

export const checkPageLoaded = (pageID, user, loaded) => {
    const requiredStatus = process.env.REACT_APP_DISABLE_COMPLETED ? ['INCOMPLETE'] 
                        : user['show_completed'] ? ['INCOMPLETE', 'COMPLETED'] 
                        : ['INCOMPLETE']
    const requiredPages = requiredStatus.map(status => (`${pageID}_${status}`))
    const difference = _.difference(requiredPages, loaded)
    return { loaded: difference.length > 0 ? false : true, toLoad: difference.map(id => id.split('_')[1]) }
}